// const initMuStickyMenu = () => {
//     const stickyMenu = document.querySelector(".js-sticky-menu");
//     if (!stickyMenu) return;

//     const header = document.querySelector("header");

//     const offset =
//         (header?.offsetHeight || 0) +
//         stickyMenu.offsetHeight;

//     /* -----------------------------
//        ScrollSpy
//     ----------------------------- */
//     const spy = new bootstrap.ScrollSpy(document.body, {
//         target: "#sticky-menu-nav",
//         offset
//     });

//     bootstrap.ScrollSpy.getInstance(document.body)?.refresh();

//     /* -----------------------------
//        Elements
//     ----------------------------- */
//     const mobileSelect = stickyMenu.querySelector("#dropdown-menu");
//     const dropdown = stickyMenu.querySelector("#muDropdown");
//     const selected = stickyMenu.querySelector("#muDropdownSelected");
//     const menuItems =
//         stickyMenu.querySelectorAll(".mu-dropdown__item");

//     /* -----------------------------
//        Sync mobile dropdown on scroll
//     ----------------------------- */
//     document.addEventListener(
//         "activate.bs.scrollspy",
//         event => {
//             const activeLink = event.relatedTarget;
//             if (!activeLink || !mobileSelect) return;

//             const hash = activeLink.getAttribute("href");
//             if (!hash?.startsWith("#")) return;

//             const value = hash.slice(1);

//             if (mobileSelect.value !== value) {
//                 mobileSelect.value = value;

//                 const option =
//                     mobileSelect.options[mobileSelect.selectedIndex];

//                 if (selected) {
//                     selected.textContent = option.textContent;
//                 }

//                 stickyMenu
//                     .querySelectorAll(".mu-dropdown__item")
//                     .forEach(item => item.classList.remove("active"));

//                 const activeItem = [...stickyMenu.querySelectorAll(".mu-dropdown__item")]
//                     .find(i => i.textContent === option.textContent);

//                 activeItem?.classList.add("active");
//             }
//         }
//     );

//     /* -----------------------------
//        Mobile dropdown navigation
//        (native select is source of truth)
//     ----------------------------- */
//     mobileSelect?.addEventListener("change", e => {
//         const id = e.target.value;
//         const target = document.getElementById(id);
//         if (!target) return;

//         const y =
//             target.getBoundingClientRect().top +
//             window.scrollY -
//             offset;

//         window.scrollTo({
//             top: y,
//             behavior: "smooth"
//         });
//     });
// };

// export default initMuStickyMenu;

const initMuStickyMenu = () => {
    const stickyMenu = document.querySelector(".js-sticky-menu");
    if (!stickyMenu) return;

    const header = document.querySelector("header");
    const mobileSelect = stickyMenu.querySelector("#dropdown-menu");
    const selected = stickyMenu.querySelector("[data-dropdown-selected]");
    const dropdownItems = [...stickyMenu.querySelectorAll(".mu-dropdown__item")];

    let offset = 0;
    let spy = null;

    const calcOffset = () => {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const headerHeight = isMobile ? 0 : (header?.offsetHeight || 0);
    return headerHeight + stickyMenu.offsetHeight;
};

    const initScrollSpy = () => {
        bootstrap.ScrollSpy.getInstance(document.body)?.dispose();
        spy = new bootstrap.ScrollSpy(document.body, {
            target: "#sticky-menu-nav",
            offset
        });
    };

    offset = calcOffset();
    initScrollSpy();

    /* -----------------------------
       Recalculate offset on resize
    ----------------------------- */
    let resizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            offset = calcOffset();
            if (spy?._config) spy._config.offset = offset;
            spy?.refresh();
        }, 150);
    });

    /* -----------------------------
       Shared: set state by index
       (option index === item index)
    ----------------------------- */
    const setActiveByIndex = index => {
        const option = mobileSelect?.options[index];
        if (!option) return;

        if (mobileSelect.value !== option.value) {
            mobileSelect.value = option.value;
        }

        if (selected) selected.textContent = option.textContent.trim();

        dropdownItems.forEach((item, i) => {
            item.classList.toggle("active", i === index);
        });
    };

    /* -----------------------------
       Sync mobile dropdown on scroll
    ----------------------------- */
    document.addEventListener("activate.bs.scrollspy", event => {
        const activeLink = event.relatedTarget;
        if (!activeLink || !mobileSelect) return;

        const hash = activeLink.getAttribute("href");
        if (!hash?.startsWith("#")) return;

        const value = hash.slice(1);
        if (mobileSelect.value === value) return;

        const index = [...mobileSelect.options]
            .findIndex(o => o.value === value);
        if (index === -1) return;

        setActiveByIndex(index);
    });

    /* -----------------------------
       Scroll to a section by id
    ----------------------------- */
    const scrollToSection = id => {
        const target = document.getElementById(id);
        if (!target) return;

        const y =
            target.getBoundingClientRect().top +
            window.scrollY -
            offset;

        window.scrollTo({ top: y, behavior: "smooth" });
    };

    /* -----------------------------
       Mobile <select> navigation
    ----------------------------- */
    mobileSelect?.addEventListener("change", e => {
        scrollToSection(e.target.value);
    });

    /* -----------------------------
       Custom dropdown item clicks
       (keeps native select in sync)
    ----------------------------- */
    dropdownItems.forEach((item, index) => {
        item.addEventListener("click", () => {
            const option = mobileSelect?.options[index];
            if (!option) return;

            setActiveByIndex(index);
            scrollToSection(option.value);

            // If open/close is handled elsewhere via data-mu-dropdown,
            // this may need to trigger that instead of setting aria-expanded directly
            stickyMenu
                .querySelector("[data-mu-dropdown]")
                ?.setAttribute("aria-expanded", "false");
        });
    });
};

export default initMuStickyMenu;